// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-error .el-input__inner,.is-error .el-textarea__inner{border-color:#f56c6c}", ""]);
// Exports
module.exports = exports;
